/* eslint-disable @angular-eslint/prefer-standalone */
import { Component} from '@angular/core';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent {

}
